
export const getRequisitos = async (baseurl,institucionId,categoriaId) => {
  const URL_REQ = baseurl+ `?institucionId=${institucionId}&categoriaId=${categoriaId}`;
  // window.console.log('obteniendo requisitos',URL_REQ);

  const requestOptions = {
    method: 'GET',
  };

  let response = await fetch(URL_REQ, requestOptions);
  let res = await response.json().catch(()=>{datos=[]})
  res.datos.forEach((e) => {
    e.tipoDocumentoPersona.plantillaDatos.forEach((p) => ((p.valor = null), (p.archivo = null)));
  });
  let datos = [...res.datos];

  return datos;
};

export const getCargados = async (baseurl) => {
  const URL_REQ = baseurl;
  // window.console.log('obteniendo requisitos cargados',URL_REQ);

  const requestOptions = {
    method: 'GET',
  };

  let response = await fetch(URL_REQ, requestOptions);
  let res = await response.json().catch(()=>{datos=[]})
  let datos = [...res.datos];

  return datos;
};
